import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-frontend-editor',
  standalone: false,
  templateUrl: './frontend-editor.component.html',
  styleUrls: ['./frontend-editor.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FrontendEditorComponent {
  @Input()
  title?: string;
  @Input()
  required: boolean = false;
  @Input()
  disabled: boolean = false;
  @Input()
  value: string = '';
  @Output()
  valueChange: EventEmitter<any> = new EventEmitter();
  public editorConfig: any = {
    editable: !this.disabled,
    spellcheck: true,
    height: 'auto',
    minHeight: '200px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {
        class: 'arial',
        name: 'Arial'
      },
      {
        class: 'times-new-roman',
        name: 'Times New Roman'
      },
      {
        class: 'calibri',
        name: 'Calibri'
      },
      {
        class: 'comic-sans-ms',
        name: 'Comic Sans MS'
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [],
  };

  onEditorChange(content: string) {
    this.value = content;
    this.valueChange.emit(this.value);
  }
}
